import { API, axiosInstance } from "lib";

export const getBanksList = (data = {}) => {
  return axiosInstance
    .post(API.GET_MASTERS_BANK_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getSingleBank = (data = {}) => {
  return axiosInstance
    .post(API.GET_SINGLE_FIRM_BANK, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const createBank = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_MASTERS_BANK, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const updateBank = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_MASTERS_BANK, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const deleteBank = (data={}) => {
  return axiosInstance
    .post(API.DELETE_MASTERS_BANK , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};
